import type { PublicSlotKey } from '#packages/apilib';
import type { WizardApi } from './wizardApi';

export const WizardApiKey: PublicSlotKey<WizardApi> = {
  name: 'WizardApi',
  public: true,
};
